<div class="dialog-header tw-flex tw-justify-between">
  <h1 mat-dialog-title>Option declined details</h1>
  <mat-icon class="close tw-cursor-pointer tw-m-6" aria-hidden="false" mat-dialog-close>close</mat-icon>
</div>

<mat-dialog-content class="!tw-pt-0 !tw-pb-8 d-flex flex-column tw-gap-6">
  @if( badges.length > 0 ) {
    <div class="reasons-container">
      <div class="title">Decline reasons</div>

      <div class="reasons-list d-flex flex-wrap tw-gap-2">
        @for( badgeText of badges; track $index ) {
          <div class="reason-badge tw-text-lendio-red-500 tw-bg-lendio-red-100 tw-border tw-border-lendio-red-400">
            {{ badgeText }}
          </div>
        }
      </div>
    </div>
  }

  @if( comments.length > 0 ) {
    <div class="comments-container">
      <div class="title">Additional comments</div>

      <div class="tw-bg-lendio-cool-gray-10 tw-text-lendio-warm-gray-900 tw-p-2 tw-rounded-md">
        @for( comment of comments; track $index ) {
          <div>{{ comment }}</div>
        }
      </div>
    </div>
  }
</mat-dialog-content>
